import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonComponent } from '@components/common.component';
import { WeatherComponent } from '../../../../shared/components/weather/weather.component';
import { AnnouncementsDashboardComponent } from '../../../announcements/components/announcements-dashboard/announcements-dashboard.component';
import { MessagesDashboardComponent } from '../../../messages/components/messages-dashboard/messages-dashboard.component';
import { DiningDashboardComponent } from '../../../dining/components/dining-dashboard/dining-dashboard.component';
import { GalleryDashboardComponent } from '../../../gallery/components/gallery-dashboard/gallery-dashboard.component';
import { CalendarDashboardComponent } from '../../../calendar/components/calendar-dashboard/calendar-dashboard.component';
import { FEATURE_FLAGS, isCorporationFlagEnabled } from '@functions/feature-flag.functions';

@Component({
  selector: 'app-dashboard-resident-page',
  standalone: true,
  imports: [
    CommonModule,
    TabsModule,
    AccordionModule,
    SimplebarAngularModule,
    WeatherComponent,
    AnnouncementsDashboardComponent,
    MessagesDashboardComponent,
    DiningDashboardComponent,
    GalleryDashboardComponent,
    CalendarDashboardComponent,
  ],
  templateUrl: './dashboard-resident-page.component.html',
  styleUrl: './dashboard-resident-page.component.scss',
})
export class DashboardResidentPageComponent extends CommonComponent {
  get canShowDining(): boolean {
    return isCorporationFlagEnabled(this.community, FEATURE_FLAGS.DINING_KIOSK);
  }
}
